import React from 'react'

export const TypeFilterContext = React.createContext([])
export const CategoryFilterContext = React.createContext([])
export const relatedProductContext = React.createContext([])
